import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navbarLoaded, setNavbarLoaded] = useState(false);
  const [navbarShrink, setNavbarShrink] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setNavbarShrink(true);
    } else {
      setNavbarShrink(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setNavbarLoaded(true);
    }, 100);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`custom-navbar ${navbarLoaded ? 'loaded' : ''} ${navbarShrink ? 'shrink' : ''}`}>
      <div className="custom-logo animated-logo">
        <img src="/img/logo.png" alt="Logo" />
        <img src="/img/logo2.png" alt="Second Logo" className="second-logo" />
      </div>
      <FontAwesomeIcon
        icon={menuOpen ? faTimes : faBars}
        className="menu-icon animated-menu-icon"
        onClick={toggleMenu}
      />
      <ul className={`custom-menu animated-menu ${menuOpen ? 'open' : ''}`}>
        <li>
          <ScrollLink to="hero-section" smooth={true} duration={500}>
            INICIO
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="product-services" smooth={true} duration={500}>
            PRODUCTO
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="how-it-works" smooth={true} duration={500}>
            COMO FUNCIONA
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="product-catalog" smooth={true} duration={500}>
            CATÁLOGO
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="competitive-advantages" smooth={true} duration={500}>
            POR QUÉ ELEGIRNOS
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="client-logos" smooth={true} duration={500}>
            CLIENTES
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to="contact" smooth={true} duration={500}>
            CONTACTO
          </ScrollLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;



